<template>
    <v-card-text>
        <div class="funcionalidade-container">
            <v-row>
                <v-col cols="12" class="d-flex">
                    <h3 class="mb-4 mt-3">
                        Configuração de comissionado principal
                    </h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="10" style="display: inline-flex">
                    <v-radio-group
                            v-model="Options.HabilitarComissionadoPrincipal"
                            row
                            style="margin-top: 7px; margin-right: -20px; padding-top: 0"
                    >
                        <v-radio label="Desabilitar" :value="0"></v-radio>
                        <v-radio label="Habilitar" :value="1"></v-radio>
                        <v-radio label="Habilitar para:" :value="2"></v-radio>
                    </v-radio-group>
                    <div
                            class="div--comboBox"
                            :style="{ 'margin-bottom': isEnabled.HabilitarComissionadoPrincipal ? '-26px !important' : '' }"
                    >
                        <DynamicSelect
                                placeholder="Selecione as unidades"
                                v-model="unidadesNegocioSelecionadas.HabilitarComissionadoPrincipal"
                                endpoint="/dynamic-selects/unidades/id"
                                :class="{ isDisabled: !isEnabled.HabilitarComissionadoPrincipal, comboBoxEnorme: true }"
                                :disabled="!isEnabled.HabilitarComissionadoPrincipal" confirm-on-clear
                        />
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-row>
            <v-col cols="10" class="mt-7"></v-col>
            <v-col cols="2" class="mt-7">
                <v-btn class="transition button-right" color="primary" rounded @click="salvarFuncionalidadesDoSistema">
                    Salvar
                </v-btn>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { ValuesFunctionalities } from '@/plugins/constants'
  import { AlertTypes } from '../../plugins/alerts_types'

  export default {
    name: 'ConfiguracaoUnidadesNegocio',
    data: () => ({
      OptionsEach: ['HabilitarComissionadoPrincipal'],
      Options: {
        HabilitarComissionadoPrincipal: 0
      },
      unidadesNegocioSelecionadas: {
        HabilitarComissionadoPrincipal: []
      },
      isEnabled: {
        HabilitarComissionadoPrincipal: false
      },
      NomeColunas: {
        HabilitarComissionadoPrincipal: 'habilitar_comissionado_principal'
      },
      NomeFuncionalidade: {
        HabilitarComissionadoPrincipal: 'HabilitarComissionadoPrincipal'
      }
    }),
    watch: {
      'Options.HabilitarComissionadoPrincipal' () {
        this.isEnabled.HabilitarComissionadoPrincipal = this.Options.HabilitarComissionadoPrincipal === ValuesFunctionalities.HABILITAR_PARA
      }
    },
    mounted () {
      Promise.all([this.SetarDadosFuncionalidades()])
    },
    methods: {
      async SetarDadosFuncionalidades () {
        try {
          await this.$http.post('/painel/configuracao/restricoes_unidade/get', { nome_colunas: this.NomeColunas }).then(response => {
            let data = response.data.restricoes
            data.forEach(dado => {
              this.Options[dado.funcionalidade] = dado.config
              this.unidadesNegocioSelecionadas[dado.funcionalidade] = JSON.parse(dado.unidades_negocio)
            })
          })
        } catch (e) {
          console.error(e)
          notification(AlertTypes.ERROR, 'Erro ao consultar as configurações das funcionalidades no painel administrativo.')
        }
      },
      limparCampos () {
        this.OptionsEach.forEach(option => {
          if (this.Options[option] !== ValuesFunctionalities.HABILITAR_PARA && this.unidadesNegocioSelecionadas[option].length > 0) {
            this.unidadesNegocioSelecionadas[option] = []
          }
        })
      },
      async salvarFuncionalidadesDoSistema () {
        if ((this.Options.HabilitarComissionadoPrincipal === ValuesFunctionalities.HABILITAR_PARA && this.unidadesNegocioSelecionadas.HabilitarComissionadoPrincipal.length === 0)) {
          notification(AlertTypes.WARN, 'Necessário informar ao menos 1 usuário para acesso das funcionalidades listadas.')
          return
        }

        this.limparCampos()

        try {
          await this.$http.post('/painel/configuracao/restricoes_unidade/salvar', {
            options: this.Options,
            unidades: this.unidadesNegocioSelecionadas,
            nome_funcionalidade: this.NomeFuncionalidade,
            nome_colunas: this.NomeColunas
          })
          notification(AlertTypes.SUCCESS, 'Configuração atualizada com sucesso!')
        } catch (e) {
          notification(AlertTypes.ERROR, 'Não foi possível atualizar a configuração, tente novamente mais tarde!')
        }
      }
    }
  }
</script>

<style scoped>
.v-card__text {
  margin-top: 8px;
}

.row {
  align-items: center;
}

.v-input__control {
  align-items: center;
  justify-items: center;
}

.v-input {
  display: flex;
  align-items: center;
}

.v-input--selection-controls {
  margin-top: 1.5rem;
}

.mt-7 {
  align-self: flex-end;
}

.div--comboBox {
  width: 65%;
}

.comboBoxEnorme {
  max-width: 100%;
  margin-bottom: 0px !important;
  margin: 16px !important;
}

.parametros__sistema__h4 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.isDisabled {
  overflow: hidden !important;
  border-radius: 10px;
  background-color: #efefef !important;
}
</style>
